<template>
  <div class="main-container">
    <!-- 上方区域 -->
    <div class="top-section">
      <el-input
          @change="contentChange"
          type="textarea"
          v-model="content"
          placeholder="蝉妈妈载荷"
          style="width: 48%; height: 50px;"
      ></el-input>
      <el-input
          type="textarea"
          v-model="cookie"
          placeholder="Cookie*"
          style="width: 48%; height: 50px;"
      ></el-input>
    </div>

    <!-- 按钮区域 -->
    <div class="button-section">
      <el-select v-model="selectedPage" style="width: 180px;">
        <el-option label="翻页导入" value="page1"></el-option>
        <el-option label="页码导入" value="page2"></el-option>
      </el-select>

      <el-input v-if="selectedPage === 'page1'" v-model="nowPage" style="width: 150px;">
        <template #prepend>当前页</template>
      </el-input>

      <el-input v-if="selectedPage === 'page2'" style="width: 150px;">
        <template #prepend>到某页</template>
      </el-input>

      <el-button v-if="selectedPage === 'page2'">开始查询</el-button>
      <el-button
          v-if="selectedPage === 'page1'"
          @click="nextpage"
          :loading="loadingNextPage"
          :disabled="isCmmDataBusy"
      >
        下一页
      </el-button>


      <el-button type="danger" @click="deleteSelectedRows" :disabled="isCmmDataBusy">删除</el-button>
      <el-button type="primary" @click="copyCookie" v-if="hasAuth('sys:cmm:copycookie')">复制cookie</el-button>
    </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table
          :data="paginatedData"
          border
          stripe
          height="90%"
          @selection-change="handleSelectionChange"
          ref="tableRef"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" width="80">
          <template #default="{ $index }">
            {{ (currentPage - 1) * pageSize + $index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" width="220"></el-table-column>
        <el-table-column prop="pic" label="主图" width="60">
          <template #default="{ row }">
            <div class="thumbnail-wrapper" @mouseenter="showLargeImagePopup(row.pic)" @mouseleave="hideLargeImagePopup">
              <img :src="row.pic" class="thumbnail" alt="主图" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" width="800"></el-table-column>
        <el-table-column prop="shopName" label="店铺" sortable></el-table-column>
        <el-table-column prop="brand" label="品牌" sortable></el-table-column>
        <el-table-column prop="price" label="价格" sortable></el-table-column>
        <el-table-column prop="cos" label="佣金" sortable></el-table-column>
        <el-table-column prop="statu" label="状态" sortable>
          <template #default="{ row }">
            <el-tag size="small" v-if="row.statu === 1" type="success">成功</el-tag>
            <el-tag size="small" v-else-if="row.statu === 0" type="danger">失败</el-tag>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        />
      </div>
    </div>

    <!-- 放大图显示区域 -->
    <div v-if="showLargeImage" class="large-image-container">
      <img :src="largeImageSrc" class="large-image" alt="放大图" />
    </div>

    <!-- 底部区域 -->
    <div class="footer-section">
      <el-select v-model="selectedDatang" style="width: 180px;">
        <el-option label="大唐复制" value="datang"></el-option>
        <el-option label="其它上货" value="others"></el-option>
      </el-select>

      <el-input v-if="selectedDatang === 'datang' && hasAuth('sys:cmm:lirun')" v-model="lirun" style="width: 150px;">
        <template #prepend>利润</template>
      </el-input>

      <el-button
          type="primary"
          size="small"
          @click="falterweijinci"
          :loading="loadingFilter"
          :disabled="isCmmDataBusy"
      >
        违禁词过滤
      </el-button>
      <el-button type="primary" size="small" @click="downLoadData"
                 :loading="loadingdownLoadData"
                 :disabled="isCmmDataBusy"
      >
        导出数据
      </el-button>


      <el-button type="primary" size="small" @click="downLoadZIP" v-if="hasAuth('sys:cmm:downloadzip')"
                 :loading="loadingZIPPage"
                 :disabled="isCmmDataBusy"
      >
        下载数据包
      </el-button>

    </div>

  </div>
</template>

<script>
import JSZip from "jszip";
import $axios from "core-js/internals/internal-state";
import {date} from "mockjs/src/mock/random/date";
import {createKeywordMatcher} from "@/utils/keywordMatcher";

function toText(value) {
  if (value === null || typeof value === "undefined") {
    return "";
  }
  return typeof value === "string" ? value : String(value);
}

const FILTER_YIELD_CHECK_INTERVAL = 256;
const FILTER_YIELD_BUDGET_MS = 12;

function now() {
  return typeof performance !== "undefined" && typeof performance.now === "function"
      ? performance.now()
      : Date.now();
}

function yieldToBrowser() {
  return new Promise(resolve => setTimeout(resolve, 0));
}

// Keep the exact literal, case-sensitive matching semantics while yielding only
// between rows. This lets a large local filtering run keep the UI responsive
// without changing which titles or brands match.
async function filterRowsLocally(rows, brandMatcher, forbiddenMatcher) {
  const filteredRows = [];
  let lastYieldAt = now();

  for (let index = 0; index < rows.length; index += 1) {
    const row = rows[index];
    const title = toText(row && row.title);
    const brand = toText(row && row.brand);

    if (!brandMatcher.containsAny(title) && !brandMatcher.containsAny(brand)) {
      filteredRows.push(Object.assign({}, row, {
        title: forbiddenMatcher.removeAll(title)
      }));
    }

    const hasMoreRows = index + 1 < rows.length;
    if (hasMoreRows && (index + 1) % FILTER_YIELD_CHECK_INTERVAL === 0 && now() - lastYieldAt >= FILTER_YIELD_BUDGET_MS) {
      await yieldToBrowser();
      lastYieldAt = now();
    }
  }

  return filteredRows;
}

export default {
  data() {
    return {
      selectedPage: "page1",
      content: "",
      cookie: "",
      tableData: [],
      selectedRows: [],
      nowPage: 0,
      lirun: 20,
      selectedDatang: "datang",
      showLargeImage: false,
      largeImageSrc: "",
      loadingNextPage: false,
      loadingZIPPage: false,
      loadingdownLoadData : false,
      loadingFilter: false,
      currentPage: 1,
      pageSize: 50,
      pageSizes: [ 50, 100, 150, 200]
    };
  },
  computed: {
    isCmmDataBusy() {
      return this.loadingNextPage || this.loadingFilter || this.loadingdownLoadData || this.loadingZIPPage;
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.tableData.slice(start, start + this.pageSize);
    },
    total() {
      return this.tableData.length;
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    deleteSelectedRows() {
      if (this.isCmmDataBusy) return;
      if (this.selectedRows.length === 0) return this.$message.warning('请先选择要删除的行');
      this.tableData = this.tableData.filter(row => !this.selectedRows.includes(row));
      this.selectedRows = [];
      if (this.currentPage > 1 && this.paginatedData.length === 0) this.currentPage--;
      this.$message.success('删除成功');
    },
    showLargeImagePopup(src) {
      this.largeImageSrc = src;
      this.showLargeImage = true;
    },
    hideLargeImagePopup() {
      this.showLargeImage = false;
    },
    contentChange() {
      if (!this.content) return;
      this.$axios.post("/sys/cmm/contentChange", { content: this.content })
          .then(res => {
            if (res.data.data === 'fail') {
              this.$alert('负载格式错误，已清空', '格式错误');
              this.content = "";
            } else {
              this.nowPage = res.data.data.nowpage;
            }
          });
    },
    nextpage() {
      if (this.isCmmDataBusy) return;
      this.loadingNextPage = true; // 开始加载，禁用按钮
      this.$axios.post("/sys/cmm/nextPage", {
        content: this.content,
        cookie: this.cookie
      }).then(res => {
        if (res.data.data === 'fail') {
          this.$alert('Cookie过期或不存在，已清空', '格式错误');
          this.cookie = '';
        } else {
          this.tableData.push(...res.data.data.resList);
          this.content = res.data.data.fuzai;
          this.nowPage = res.data.data.nowpage;
          this.currentPage = Math.ceil(this.tableData.length / this.pageSize);
        }
      }).catch(err => {
        console.error(err);
        this.$message.error('请求失败');
      }).finally(() => {
        this.loadingNextPage = false; // 请求结束，恢复按钮状态
      });
    },

    copyCookie() {
      this.$axios.get("/sys/cmm/copyCookie").then(res => {
        if (res.data.data === 'fail') {
          this.$alert('Cookie不存在', '错误');
        } else {
          this.cookie = res.data.data.cmmCookie;
          const cookieText = res.data.data.cmmCookieJson;

          // 使用老式复制方法作为回退
          const textarea = document.createElement('textarea');
          textarea.value = cookieText;
          textarea.style.position = 'fixed';  // 避免滚动到底部
          document.body.appendChild(textarea);
          textarea.select();

          try {
            const successful = document.execCommand('copy');
            if(successful) {
              this.$message.success('Cookie 已复制到剪切板');
            } else {
              throw new Error('复制命令失败');
            }
          } catch (err) {
            this.$message.error('复制失败: ' + err.message);
          } finally {
            document.body.removeChild(textarea);
          }
        }
      });
    },

    async falterweijinci() {
      if (this.isCmmDataBusy) return;
      if (this.tableData.length === 0) {
        this.$message.warning("当前没有可过滤的商品");
        return;
      }

      this.loadingFilter = true;
      try {
        const [forbiddenResponse, brandResponse] = await Promise.all([
          this.$axios.get("/sys/weijinci/getweijinci"),
          this.$axios.get("/sys/weijinci/getbrands")
        ]);
        const forbiddenTerms = forbiddenResponse && forbiddenResponse.data && forbiddenResponse.data.data;
        const brandTerms = brandResponse && brandResponse.data && brandResponse.data.data;
        if (!Array.isArray(forbiddenTerms) || !Array.isArray(brandTerms)) {
          throw new Error("过滤规则返回格式不正确");
        }

        const forbiddenMatcher = createKeywordMatcher(forbiddenTerms.map(item => item && item.forbiddenWord), "违禁词");
        const brandMatcher = createKeywordMatcher(brandTerms.map(item => item && item.brand), "品牌");
        // Snapshot the product references only after the current rules have
        // arrived. All product-mutating actions are mutually exclusive while
        // filtering, so this is a stable source for the chunked local scan.
        const sourceRows = this.tableData.slice();
        const originalCount = sourceRows.length;
        this.tableData = await filterRowsLocally(sourceRows, brandMatcher, forbiddenMatcher);

        this.selectedRows = [];
        this.currentPage = 1;
        await this.$nextTick();
        if (this.$refs.tableRef && typeof this.$refs.tableRef.clearSelection === "function") {
          this.$refs.tableRef.clearSelection();
        }
        this.$message.success(`过滤完成：保留 ${this.tableData.length} 条，移除 ${originalCount - this.tableData.length} 条`);
      } catch (error) {
        console.error("读取违禁词过滤规则失败:", error);
        this.$message.error("读取过滤规则失败，请稍后重试");
      } finally {
        this.loadingFilter = false;
      }
    },
    /*downLoadData() {
      this.loadingdownLoadData = true; // 开始加载，禁用按钮
      const lirun = this.selectedDatang === 'datang' ? this.lirun : -1;
      this.$axios.post("/sys/cmm/downLoadData", { tableData: this.tableData, lirun, datang: this.selectedDatang, fuzai: this.content })
          .then(res => {
            const blob = new Blob([res.data.data.join('\r\n')], { type: 'text/plain;charset=utf-8' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'data.txt';
            link.click();
          });
      this.loadingdownLoadData = false;
    },*/



    // 下载数据主函数
    async downLoadData() {
      if (this.isCmmDataBusy) return;
      this.loadingdownLoadData = true;
      try {
        // 1. 并行获取 roleID 和初始数据
        const [roleRes, initialData] = await Promise.all([
          this.$axios.post("/sys/cmm/getRoleID"),
          this.fetchInitialData()
        ]);

        const roleID = roleRes.data.data;
        const shouldProcessProtection =
            initialData.length >= 500 && ![1, 2].includes(Number(roleID));

        // 2. 获取全部数据（分页拉取）
        const allLines = initialData.length >= 500
            ? await this.fetchRemainingData(initialData, 500)
            : initialData;

        // 3. 处理保护内容
        if (shouldProcessProtection) {
          const protectionContent = await this.$axios.get("/sys/cmm/getProtectionContent")
              .then(res => res.data.data || [])
              .catch(() => []);
          if (protectionContent.length > 0) {
            await this.processProtectionLines(allLines, protectionContent);
          }
        }

        // 4. 下载文件
        this.downloadFile(allLines);
      } catch (error) {
        console.error('下载失败:', error);
        this.$message.error(`数据下载失败: ${error.message}`);
      } finally {
        this.loadingdownLoadData = false;
      }
    },

// 获取初始数据（前500条）
    async fetchInitialData() {
      const lirun = this.selectedDatang === 'datang' ? this.lirun : -1;
      const res = await this.$axios.post("/sys/cmm/downLoadDataPart", {
        tableData: this.tableData,
        lirun,
        datang: this.selectedDatang,
        fuzai: this.content,
        pageIndex: 0,
        pageSize: 500
      });
      return res.data.data || [];
    },

// 分页获取剩余数据（确保 pageSize 一致）
    async fetchRemainingData(initialData, pageSize = 500) {
      const allLines = [...initialData];
      let pageIndex = 1;

      while (true) {
        const lirun = this.selectedDatang === 'datang' ? this.lirun : -1;
        const res = await this.$axios.post("/sys/cmm/downLoadDataPart", {
          tableData: this.tableData,
          lirun,
          datang: this.selectedDatang,
          fuzai: this.content,
          pageIndex,
          pageSize
        });

        const lines = res.data.data || [];
        if (lines.length === 0) break;

        allLines.push(...lines);
        if (lines.length < pageSize) break;

        pageIndex++;
      }

      return allLines;
    },

    // 处理保护行：将所有包含受保护dyid的行替换为不包含dyid的行，确保总量不变
    async processProtectionLines(lines, protectionContent) {
      const protectionMap = new Map();
      protectionContent.forEach(dyid => {
        if (dyid && typeof dyid === 'string') {
          protectionMap.set(dyid.trim(), true);
        }
      });

      // 标记所有受保护行
      const protectedIndices = [];
      const safeLines = [];

      lines.forEach((line, index) => {
        if (this.isProtectedLine(line, protectionMap)) {
          protectedIndices.push(index);
        } else {
          safeLines.push(line);
        }
      });

      // 替换受保护行
      for (const index of protectedIndices) {
        if (safeLines.length === 0) {
          break;
        }

        const randomSafeLine = safeLines[Math.floor(Math.random() * safeLines.length)];
        lines[index] = randomSafeLine;
      }

      // 异步节流防止阻塞主线程（非必要，但保留结构）
      await new Promise(resolve => setTimeout(resolve, 0));
    },

// 检测行是否是受保护的行
    isProtectedLine(line, protectionMap) {
      if (!line) return false;

      // 确保 line 是字符串
      let lineStr = '';
      if (typeof line === 'string') {
        lineStr = line;
      } else {
        // 如果是对象，转为字符串检查
        lineStr = JSON.stringify(line);
      }

      for (const dyid of protectionMap.keys()) {
        if (lineStr.includes(dyid)) {
          return true;
        }
      }
      return false;
    },



// 下载数据为文件
    downloadFile(lines) {
      const blob = new Blob([lines.join('\r\n')], {
        type: 'text/plain;charset=utf-8'
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${new Date().toISOString().slice(0, 10)}_data.txt`;

      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    },





    async downLoadZIP() {
      if (this.isCmmDataBusy) return;
      this.loadingZIPPage = true; // 开始加载，禁用按钮
      try {
        let roleID = '';
        // 获取 roleID
        const roleRes = await this.$axios.post("/sys/cmm/getRoleID");
        roleID = roleRes.data.data;  // 获取返回的 roleID

        // 创建一个 JSZip 实例
        const zip = new JSZip();
        let fileIndex = 1;  // 文件编号，用于命名

        // 遍历 tableData，依次发送请求
        for (const row of this.tableData) {
          // 合并 roleID 和 row 数据
          const dataToSend = { ...row, roleID, lirun: this.lirun };

          // 请求获取详情
          const res = await this.$axios.post("/sys/cmm/getDetails", dataToSend, {
            headers: {
              'Content-Type': 'application/json'
            }
          });
          // 处理返回的数据
          if (res.data.data !== '0') {

            const txtData = res.data.data;  // 假设返回的数据是文本内容
            // 使用当前行的 Id 字段作为文件名
            const fileName = `${row.id}.txt`; // 使用当前行的 Id 字段命名文件

            // 创建 .txt 文件并添加到 zip 中
            zip.file(fileName, txtData);

            // 更新当前行的 statu 字段为 "成功"
            this.$set(row, "statu", 1);

          }
          else{

            this.$set(row, "statu", 0);
          }
        }
        const content = await zip.generateAsync({ type: 'blob' });

        // 创建下载链接并触发下载
        const link = document.createElement('a');
        link.href = URL.createObjectURL(content);
        link.download = 'files.zip';  // 设置下载文件名
        link.click();  // 触发下载
        this.loadingZIPPage = false;
      } catch (error) {
        console.error("发生错误:", error);
        this.loadingZIPPage = false;
      }



    },

  }
};
</script>

<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
  height: 85vh;
  background: #f5f7fa;
  padding: 5px;
  box-sizing: border-box;
}
.top-section, .button-section, .footer-section {
  display: flex;
  gap: 10px;
  padding: 10px;
}
.table-section {
  flex: 1;
  background: #fff;
  padding: 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: auto;
}
.thumbnail-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}
.thumbnail-wrapper:hover .thumbnail {
  transform: scale(1.2);
}
.large-image-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
.large-image {
  max-width: 80vw;
  max-height: 80vh;
  border-radius: 10px;
  border: 2px solid white;
}
.pagination-section {
  margin-top: 10px;
  text-align: right;
  background: #fff;
  padding: 10px;
  border-top: 1px solid #ebeef5;
}
</style>
